import { useEffect, useState } from 'react';
import { PaymentSource } from '../../../../enum/PaymentSource';
import { t } from 'i18next';
import FilterSelectAll from './FilterSelectAll';
import OptionsList from './OptionsList';
import FilterToogleSwitch from './FilterToogleSwitch';
import usePaymentSourceCountMessage from '../../../../hook/usePaymentSourceCountMessage';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { fetchGamesFilter } from '../../../../store/slice/games-slice';
import Search from '../../Common/Search';
import { useGamesFilter, Games } from '../../../../hook/useGamesFilter';
import useGamesCountMessage from '../../../../hook/useGamesCountMessage';
import { useOtherFilter } from '../../../../hook/useOtherFilter';
import { otherFiltersList } from '../../../../config/OtherFiltersList';

interface GeoFiltersProps {
  toggleDropdown: (type: string, index: number) => void;
  isOpen: (type: string, index: number) => boolean;
  filters: any;
  setFilters: (newFilters: {}) => void;
  justClosed: { type: string; index: number } | null;
}

const OtherFilters: React.FC<GeoFiltersProps> = ({ toggleDropdown, isOpen, filters, setFilters, justClosed }) => {
  const columns = [PaymentSource.PAYMENT_SOURCE, Games.GAMES];
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchGamesFilter({ text: '' }));
  }, [dispatch]);

  const { gamesFilterOptions, filteredData, handleFilteredData } = useGamesFilter();

  const [sum, setSum] = useState(true);
  const getPaymentSourceCountMessage = usePaymentSourceCountMessage();
  const getGamesCountMessage = useGamesCountMessage();

  const { selectAll, numberOfSelected, handleChange } = useOtherFilter(filters, setFilters, columns);

  return (
    <div className="filters other_filters">
      {otherFiltersList.map((filterList: any, idx) => (
        <div
          key={filterList.key}
          className={`filter_select ${isOpen(filterList.label, idx) ? 'opened' : ''} ${
            justClosed?.type === filterList.label && justClosed?.index === idx ? 'closed' : ''
          } ${numberOfSelected[filterList.key] > 0 ? 'expanded' : ''} ${filterList.key}`}
          onClick={() => toggleDropdown(filterList.label, idx)}
        >
          {filterList.hasSwitch ? (
            <>
              <div className={`payment_source_title  ${!isOpen(filterList.label, idx) ? 'with_padding' : ''}`}>
                <span className="dropdown_title">
                  {numberOfSelected[PaymentSource.PAYMENT_SOURCE] > 0 && (
                    <span className="number_of_selected">{numberOfSelected[PaymentSource.PAYMENT_SOURCE]}</span>
                  )}
                  {getPaymentSourceCountMessage(numberOfSelected[PaymentSource.PAYMENT_SOURCE])}
                  {isOpen(filterList.label, idx) && (
                    <FilterToogleSwitch
                      checked={sum}
                      toogleSwitch={() => setSum(!sum)}
                      title={t(filterList.switchLabel)}
                    />
                  )}
                </span>
              </div>
            </>
          ) : filterList.key === Games.GAMES ? (
            <span className={`dropdown_title  ${!isOpen(filterList.label, idx) ? 'with_padding' : ''}`}>
              {numberOfSelected[Games.GAMES] > 0 && (
                <span className="number_of_selected">{numberOfSelected[Games.GAMES]}</span>
              )}
              {getGamesCountMessage(numberOfSelected[Games.GAMES])}
            </span>
          ) : (
            <span className={`dropdown_title  ${!isOpen(filterList.label, idx) ? 'with_padding' : ''}`}>
              {t(filterList.label)}
            </span>
          )}
          <div className="options_container" onClick={(e) => e.stopPropagation()}>
            {filterList.search && (
              <Search
                placeholder={t('general.search')}
                className="games_filter_search"
                data={gamesFilterOptions}
                searchKeys={[t('statisticPage.header.filter.dropdown.geoFilters.name')]}
                onFilteredData={handleFilteredData}
              />
            )}
            <div className="options_list">
              {filterList.type === 'radio' && (
                <OptionsList
                  column={filterList.key}
                  filters={filters}
                  filteredOptions={filterList.options}
                  checkbox={false}
                />
              )}

              {filterList.type === 'checkbox' && (
                <>
                  <FilterSelectAll
                    className="select_all_wrapper"
                    checked={
                      filters[filterList.key]?.length ===
                      (filterList.key === Games.GAMES
                        ? filteredData?.length > 0 && filteredData?.length
                        : filterList.options?.length)
                    }
                    selectAll={() =>
                      filterList.key === Games.GAMES
                        ? selectAll(filterList.key, filteredData)
                        : selectAll(filterList.key, filterList.options)
                    }
                    title={t('statisticPage.header.filter.dropdown.all')}
                  />
                  <OptionsList
                    checkbox={true}
                    column={filterList.key}
                    filters={filters}
                    handleChange={handleChange}
                    filteredOptions={filterList.key === Games.GAMES ? filteredData : filterList.options}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default OtherFilters;
